import { featureCollection, lineString, point } from '@turf/helpers';
import { Layer, Marker, Source } from 'react-map-gl/mapbox';
import { useTranslation } from 'react-i18next';

interface Props {
  measurePoints: [number, number][];
  totalDistance: number;
  formattedDistance: string;
}

function MapMeasureLayer({ measurePoints, totalDistance, formattedDistance }: Props) {
  const { t } = useTranslation('admin/map');

  if (measurePoints.length === 0) return null;

  const pointsData = featureCollection(measurePoints.map((p) => point(p)));
  const lastPoint = measurePoints[measurePoints.length - 1];

  return (
    <>
      {measurePoints.length >= 2 && (
        <Source id='measure-line' type='geojson' data={lineString(measurePoints)}>
          <Layer
            id='measure-line-layer'
            type='line'
            paint={{
              'line-color': '#3b82f6',
              'line-width': 3,
              'line-dasharray': [2, 2],
            }}
          />
        </Source>
      )}

      <Source id='measure-points' type='geojson' data={pointsData}>
        <Layer
          id='measure-points-layer'
          type='circle'
          paint={{
            'circle-radius': 6,
            'circle-color': '#ffffff',
            'circle-stroke-color': '#3b82f6',
            'circle-stroke-width': 2,
          }}
        />
      </Source>

      {measurePoints.length > 0 && (
        <Marker longitude={lastPoint[0]} latitude={lastPoint[1]} anchor='left'>
          <div className='ml-3 rounded-xl border border-[#DBEAFE] bg-white/95 px-3 py-2 text-xs text-[#0F172A] shadow-[0_12px_30px_rgba(59,130,246,0.18)] backdrop-blur-sm'>
            <div className='mb-0.5 text-[10px] font-medium uppercase tracking-[0.08em] text-[#64748B]'>
              {t('controls.total length')}
            </div>
            <div className='font-semibold text-[#2563EB]'>{formattedDistance}</div>
            {measurePoints.length === 1 && (
              <div className='mt-0.5 text-[10px] text-[#94A3B8]'>{t('controls.select next point')}</div>
            )}
          </div>
        </Marker>
      )}
    </>
  );
}

export default MapMeasureLayer;
